import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { appelApi } from './api';
import { parametresVueGlobale } from './useVueGlobale';

/**
 * Apprenants & entreprises (TF-481) : les entreprises où sont aujourd'hui les
 * apprenants, par secteur, pour préparer les visites. Qui est dans quelle
 * entreprise, le regroupement des secteurs et les compteurs sont des lectures
 * de l'API (`domain/apprenants-entreprises.ts`) : l'écran affiche.
 */

export type NatureContratEmploi = 'APPRENTISSAGE' | 'PROFESSIONNALISATION';

/** Valeur du filtre « Secteur non renseigné ». */
export const SANS_SECTEUR = 'AUCUN';

export interface ApprenantEnEntreprise {
  id: string;
  nom: string;
  prenom: string;
  siteCode: string;
  formation: { code: string; titre: string } | null;
  nature: NatureContratEmploi;
  libelleContrat: string;
  /** Accord d'un parcours OF, et non contrat du dossier CFA. */
  accord: boolean;
  debut: string;
  fin: string | null;
  /** Rupture à venir : dernier jour dans l'entreprise. */
  dernierJour: string | null;
  tuteur: { nom: string; prenom: string; telephone: string | null; email: string | null } | null;
}

export interface EntrepriseAvecApprenants {
  id: string;
  denomination: string;
  secteur: string | null;
  cleSecteur: string | null;
  adresse: string | null;
  codePostal: string | null;
  ville: string | null;
  telephone: string | null;
  email: string | null;
  contactOperationnel: string | null;
  apprenants: ApprenantEnEntreprise[];
}

export interface ReponseApprenantsEntreprises {
  calculeLe: string;
  jour: string;
  compteurs: { entreprises: number; apprenants: number; secteurs: number; sansSecteur: number };
  options: {
    secteurs: { cle: string; libelle: string; entreprises: number }[];
    formations: { code: string; titre: string }[];
  };
  entreprises: EntrepriseAvecApprenants[];
}

export interface FiltresApprenantsEntreprises {
  site: string;
  secteur: string;
  formation: string;
  recherche: string;
}

export function useApprenantsEntreprises(filtres: FiltresApprenantsEntreprises) {
  const chaine = parametresVueGlobale({ ...filtres });
  return useQuery({
    queryKey: ['apprenants-entreprises', chaine],
    queryFn: () => appelApi<ReponseApprenantsEntreprises>(`/apprenants-entreprises?${chaine}`),
    placeholderData: keepPreviousData,
  });
}
